<template>
  <div style="padding: 0 32px 0 48px;">
    <Descriptions :gutter="24">
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.productFuncType')"
      >
        {{ $t('Product.property') }}
      </DescriptionsItem>
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.productFuncName')"
      >
        {{ info.name | format }}
      </DescriptionsItem>
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.identifier')"
      >
        {{ info.identifier | format }}
      </DescriptionsItem>
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.dataType')"
      >
        {{ info.dataType | format }}
      </DescriptionsItem>
      <DataTypeDetailItem
        :info="info"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :isFirstLevel="false"
      ></DataTypeDetailItem>
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.accessMode')"
      >
        {{ info.accessMode | formAccessMode }}
      </DescriptionsItem>
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Common.desc')"
      >
        {{ info.desc | format }}
      </DescriptionsItem>
    </Descriptions>
  </div>
</template>

<script>
import Descriptions from '@/components/Descriptions'
import DescriptionsItem from '@/components/Descriptions/DescriptionsItem'
import DataTypeDetailItem from './DataTypeDetailItem'
import i18n from '@/locales/index'
import { format } from '@/utils/utils'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    },
    tslVersionId: {
      type: String
    }
  },
  components: {
    Descriptions,
    DescriptionsItem,
    DataTypeDetailItem
  },
  data() {
    return {
      info: { specs: {} },
      labelWidth: '100px',
      labelAlign: 'right'
    }
  },
  created() {
    if (this.tslVersionId) {
      this.getDetail()
    }
  },
  filters: {
    format,
    formAccessMode(val) {
      if (val === 'r') {
        return `${i18n.t('Product.Rmode')}`
      } else if (val === 'rw') {
        return `${i18n.t('Product.RWmode')}`
      } else {
        return '-'
      }
    }
  },
  methods: {
    getDetail() {
      const params = {
        tslVersionId: this.tslVersionId,
        identifier: this.row.identifier
      }
      this.$ajax
        .get(this.$api.product.product_tsl_property_detail, params)
        .then((res) => {
          this.info = res.data
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped></style>
